<template>
  <div class="cabinet-detail-container">
    <div class="jc-page-header">
      <h1>
        <a href="javascript:void(0)" @click="jump_to_up()">
          <i class="el-icon-arrow-left"></i>
        </a>{{$t('cabinet.cabinetDetail')}}
        <small>{{cabinetDetail['cabinetNo'] | maybeEmpty}}</small>
      </h1>
    </div>
    <div class="jc-page-content">

      <page-tabs
        :border-style="false"
        :tabs="getTabsData('detail')">
        <template slot="detail">
          <div class="el-section">
            <div class="el-section-header">
              <h3 class="el-section-title">{{$t('merge.basicInfo')}}</h3>
            </div>
            <div class="el-section-content">
              <div class="base-info">
                <!-- 基本信息  -->
                <div class="cabinet-detail-box">
                  <div class="item"
                    v-for="item in visibleCabinetDetailMap"
                    :key="item.label">
                    {{item.label | withColon}}
                    <span v-if="item.value == 'deviceNum'">{{cabinetDetail[item.value]}}</span>
                    <span v-else>{{cabinetDetail[item.value] | maybeEmpty}}</span>
                    <el-button type="text"
                            v-if="item.value == 'tagPairs'"
                             @click="clickOperateTag"
                             :title="$t('text.edit')">
                      <i class="el-icon-edit"></i>
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-row :gutter="20" style="margin-top:12px">
            <el-col :span="9">
              <!--设备可视化-->
              <el-tabs type="border-card">
                <div class="el-section">
                  <div class="el-section-header">
                    <h3 class="el-section-title">{{$t('cabinet.cabinetView')}}</h3>
                  </div>
                  <div class="el-section-content" >
                    <carbin-visual :data="visualizedData"
                      :showline="showVisual"
                      style="max-width: 98%;" />
                  </div>
                </div>
              </el-tabs>
            </el-col>
            <el-col :span="15">
              <!--设备列表-->
              <el-tabs type="border-card">
                <div class="el-section">
                  <div class="el-section-header">
                    <h3 class="el-section-title">{{$t('equipment.equipmentList')}}</h3>
                  </div>
                  <div class="el-section-content">
                    <el-table :data="tableData" tooltip-effect="dark" style="width: 100%"
                      v-loading="refreshloading" @sort-change="sort" @filter-change="changeFilter" >
                      <el-table-column prop="deviceNo" width="220"
                        :label="$t('equipment.equipmentNumber') + '(ID)'"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                        <a href="javascript:void(0)"
                          @click="jump_to_detail(scope.row.deviceId,scope.row.idc)"
                          class="a-link-text">{{scope.row.deviceNo}}</a>
                        </template>
                      </el-table-column>
                      <el-table-column prop="snNo" width="130" :label="$t('equipment.snNumber')"
                        show-overflow-tooltip>
                        <template slot-scope="scope">

                        <span v-if="scope.row.snNo !== ''" >{{scope.row.snNo}}</span>
                        <span v-else>--</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="rackUIndex"
                        :label="$t('text.rackUIndex')"
                        width="130"
                        sortable show-overflow-tooltip>
                        <template slot-scope="scope">
                        <span v-if="scope.row.rackUIndex !== ''" >{{scope.row.rackUIndex}}</span>
                        <span v-else>--</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="brand" :label="$t('text.brand')" show-overflow-tooltip>
                        <template slot-scope="scope">
                        <span v-if="scope.row.brand !== ''">{{scope.row.brand}}</span>
                        <span v-else>--</span>
                        </template> </el-table-column>
                      <el-table-column prop="model" :label="$t('text.model')" show-overflow-tooltip>
                        <template slot-scope="scope">
                          <span v-if="scope.row.model !== ''" >{{scope.row.model}}</span>
                          <span v-else>--</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="deviceType" :label="$t('equipment.equipmentType')"
                        show-overflow-tooltip
                        width="130"
                        :filter-multiple="false" :filtered-value="filtersValue.type"
                        :filters="filterList.deviceType" :filter-method="filtersDevicesTypes">
                        <template slot-scope="scope">
                        <span v-if="scope.row.deviceTypeName !== ''"
                          :title="scope.row.deviceTypeName">{{scope.row.deviceTypeName}}</span>
                        <span v-else>--</span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div class="el-container-table-actionBar"  v-if="tableData.length">
                      <el-pagination @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="pageSizeArr" :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total" style="float: right;margin-top: 15px;padding-bottom: 0px;">
                      </el-pagination>
                    </div>
                  </div>
                </div>
              </el-tabs>
            </el-col>
          </el-row>
        </template>
        <template slot="dynamic"></template>
      </page-tabs>
    </div>

  <!--编辑标签-->
    <jcb-tag-edit :visible.sync="editTagDialogVisible"
                  :service-code="ServiceCodeConstant.CCS"
                  :region-id="TagRegionID"
                  :resource-ids="resourceId"
                  @complete="getCabinetInfo">
    </jcb-tag-edit>
  </div>

</template>

<script>
import PageTabs from '@/components/common/PageTabs';
import CarbinVisual from '../cabinetVisual/CabinetVisual';
import DetailMixin from './detail.mixin';
import { ServiceCodeConstant } from '@/common/Constants';

export default {
  mixins: [
    DetailMixin
  ],
  components: {
    CarbinVisual,
    PageTabs
  },
  data() {
    return {
      showVisual: true,
      refreshloading: false, // 刷新
      idcId: '', // 机房id
      cabinetId: '', // 机柜id
      cabinetNo: '', // 机柜编码
      cabinetDetail: {}, // 机柜详情,
      devicesData: [], // 设备列表数据,
      cabinetDetailMap: [
        {
          // 机柜编ID
          label: this.$t('text.id'),
          value: 'cabinetId'
        },
        {
          // 机柜编码
          label: this.$t('cabinet.cabinetNumCode'),
          value: 'cabinetNo'
        },
        {
          // 机房名称
          label: this.$t('cabinet.roomName'),
          value: 'datacenterNameShow'
        },
        {
          // 节点
          label: this.$t('idcs.region'),
          value: 'regionShow'
        },
        {
          // 房间号
          label: this.$t('text.roomNum'),
          value: 'roomNo'
        },
        {
          // 机柜空间
          label: `${this.$t('cabinet.cabinetSpace')}`,
          value: 'cabinetSpace'
        },
        {
          // 额定电流
          label: `${this.$t('cabinet.ratedCurrent')}`,
          value: 'cabinetPower'
        },

        {
          // 设备数量
          label: this.$t('equipment.equipmentQuantity'),
          value: 'deviceNum'
        },
        {
          // 占用U数
          label: this.$t('cabinet.occupyU'),
          value: 'rackUOccupy'
        },
        {
          // 空闲U数
          label: this.$t('cabinet.freeU'),
          value: 'rackUFree'
        },

        // {
        //   // 计费类型
        //   label: this.$t('cabinet.billingType'),
        //   value: 'billingTypeName'
        // },
        {
          // 机柜类型
          label: this.$t('cabinet.cabinetType'),
          value: 'cabinetTypeName'
        },

        {
          // 开通状态
          label: `${this.$t('cabinet.EnablingStatus')}`,
          value: 'cabinetOpenStatusName'
        },

        {
          // 计费时间
          label: this.$t('cabinet.billingTime'),
          value: 'startTime'
        },

        {
          // 到期时间
          label: this.$t('cabinet.expireTime'),
          value: 'endTime'
        },
        {
          // 预留开始时间
          label: this.$t('cabinet.reserveStartTime'),
          value: 'reserveStartTime'
        },
        {
          // 预留结束时间
          label: this.$t('cabinet.reserveEndTime'),
          value: 'reserveEndTime'
        },
        {
          // 标签
          label: this.$t('text.tags'),
          value: 'tagPairs'
        }
      ],
      tableData: [], // 设备列表数据
      currentPage: 1, // 分页
      pageSize: 20,
      pageSizeArr: [20, 50, 100],
      total: 0,
      filtersValue: {
        type: []
      },
      filterSort: {
        order: null,
        prop: null
      },
      // 编辑标签组件是否显示
      editTagDialogVisible: false,
      resourceId: []

    };
  },
  created() {
    this.initCabinetDetail();
  },
  computed: {
    ServiceCodeConstant: () => ServiceCodeConstant,
    filterList() {
      return this.$store.state.filter.filterList;
    },
    visualizedData() { // 用于机柜可视化的数据
      return {
        ...this.cabinetDetail,
        devices: this.tableData
      };
    },
    visibleCabinetDetailMap() {
      if (this.cabinetDetail.showCurrent) return this.cabinetDetailMap;
      return this.cabinetDetailMap.filter(item => !item.shownWhenCurrent);
    }
  },
  mounted() {
    this.idcId = this.$route.query.idcId;
    this.cabinetId = this.$route.query.cabinetId;
    this.cabinetNo = this.$route.query.cabinetNo || '';
    this.getCabinetInfo();
    this.getDevicesList();
  },
  watch: {
    filtersValue: {
      handler(val, oldVal) { // eslint-disable-line no-unused-vars
        this.getDevicesList('refresh');
      },
      deep: true
    },
    filterSort: {
      handler(val, oldVal) { // eslint-disable-line no-unused-vars
        this.getDevicesList('refresh');
      },
      deep: true
    }
  },
  methods: {
    clickOperateTag () {
      this.resourceId = [].concat([this.cabinetDetail.cabinetId]);
      this.editTagDialogVisible = true;
    },
    sort(column) {
      this.currentPage = 1;
      this.filterSort.order = column.order;
      this.filterSort.prop = column.prop;
    },
    changeFilter(filter) { // eslint-disable-line no-unused-vars
      // 状态搜做默认第一页开始
      this.currentPage = 1;
    },
    initCabinetDetail() { // 设置机柜详情初始数据
      for (let i = 0; i < this.cabinetDetailMap.length; i++) {
        const key = this.cabinetDetailMap[i].value;
        this.cabinetDetail[key] = void (0);
      }
    },
    handleSizeChange(val) { // 更改数量
      this.pageSize = val;
      this.getDevicesList('refresh');
    },
    // eslint-disable-next-line no-unused-vars
    handleCurrentChange(val) { // 更改页数
      this.getDevicesList('refresh');
    },
    getCabinetInfo() { // 获取机柜详情
      const param = {
        idc: this.idcId,
        cabinetId: this.cabinetId
      };
      this.$api.getCabinetInfo(param).then((response) => {
        if (response.errno === 10000) {
          this.cabinetDetail = Object.assign({}, response.data.cabinet);
          // 格式化标签键值对
          const tagPairs = response.data.cabinet.tags;
          this.cabinetDetail.tagPairs = '';
          if (tagPairs !== undefined) {
            if (tagPairs.length > 0) {
              tagPairs.forEach((tag) => {
                this.cabinetDetail.tagPairs += `${tag.key}:${tag.value},`;
              });
              this.cabinetDetail.tagPairs = this.cabinetDetail.tagPairs.substring(0, this.cabinetDetail.tagPairs.length - 1);
            }
          }

          this.showVisual = true;
        } else {
          this.showVisual = false;
        }
      }).catch(() => {
        this.showVisual = false;
      });
    },
    getDevicesList(type) { // 获取设备列表数据
      if (type === 'refresh') {
        this.refreshloading = true;
      }
      const param = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        preciseCabinetNo: this.cabinetNo,
        regionEn: this.idcId,
        // idc: this.idcId,
        // cabinetId: this.$route.query.cabinetId
      };
      for (const key in this.filtersValue) { // 过滤
        if (Object.prototype.hasOwnProperty.call(this.filtersValue, key)) {
          if (this.filtersValue[key].length && key === 'type') {
            param.deviceType = this.filtersValue[key][0];
          }
        }
      }
      if (this.filterSort.order) { // 时间筛选
        if (this.filterSort.order === 'ascending') {
          param.sortName = this.filterSort.prop;
          param.sortDirection = 'asc';
        } else {
          param.sortName = this.filterSort.prop;
          param.sortDirection = 'desc';
        }
      }
      this.$api.getDevicesList(param).then((response) => {
        if (type === 'refresh') {
          this.refreshloading = false;
        }
        if (response.errno === 10000) {
          this.total = response.data.totalCount;
          this.tableData = Array.isArray(response.data.devices)
            ? response.data.devices.slice()
            : [];
        }
      });
    },
    filtersDevicesTypes(value, row) { // 过滤设备类型
      return row.deviceType === value;
    },
    jump_to_detail(id, idc) { // 设备详情页面
      this.$router.push({
        path: '/equipment/detail',
        query: {
          idcId: idc,
          deviceId: id
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./cabinetDetail.scss";
</style>



// WEBPACK FOOTER //
// src/components/cabinetDetail/CabinetDetail.vue